import {
  TRANSACTION_REQUEST_STATUS,
  TransactionRequestItem,
} from '@/types/transactionRequests';

export function getTransactionAmountColor(displayAmount: string) {
  switch (displayAmount[0]) {
    case '-':
      return '#DD3929';
    case '+':
      return '#0FA30C';
    default:
      return '#000000';
  }
}

export function getTransactionAmountColorWithStatus(
  transactionRequestDetail: TransactionRequestItem,
) {
  const { status, displayAmount } = transactionRequestDetail;

  if (
    status === TRANSACTION_REQUEST_STATUS.Canceled ||
    status === TRANSACTION_REQUEST_STATUS.Expired ||
    status === TRANSACTION_REQUEST_STATUS.Declined
  ) {
    return '#787878';
  }

  return getTransactionAmountColor(displayAmount);
}

export function getTransactionRequestStatus(
  status: TRANSACTION_REQUEST_STATUS,
) {
  switch (status) {
    case TRANSACTION_REQUEST_STATUS.Approved:
      return {
        statusLabel: 'Approved',
        color: '#0FA30C',
      };
    case TRANSACTION_REQUEST_STATUS.Canceled:
      return {
        statusLabel: 'Canceled',
        color: '#DD3929',
      };
    case TRANSACTION_REQUEST_STATUS.Declined:
      return {
        statusLabel: 'Declined',
        color: '#DD3929',
      };
    case TRANSACTION_REQUEST_STATUS.Expired:
      return {
        statusLabel: 'Expired',
        color: '#DD3929',
      };
    case TRANSACTION_REQUEST_STATUS.UnderReview:
      return {
        statusLabel: 'Under Review',
        color: '#787878',
      };
    default:
      return {
        statusLabel: 'Pending',
        color: '#787878',
      };
  }
}
